import { render, staticRenderFns } from "./LogisticsInfo.vue?vue&type=template&id=75473f15&scoped=true"
import script from "./LogisticsInfo.vue?vue&type=script&lang=js"
export * from "./LogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInfo.vue?vue&type=style&index=0&id=75473f15&prod&lang=scss&scoped=true"
import style1 from "./LogisticsInfo.vue?vue&type=style&index=1&id=75473f15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75473f15",
  null
  
)

export default component.exports